class Footer extends HTMLElement {
  constructor() {
    super();
    this.mount();
  }

  mount() {
    const footer = document.querySelector(".main-footer");
    if (!footer) return;

    let isAccordionActive = false;
    let listeners = [];

    const initAccordion = () => {
      const footerItems = footer.querySelectorAll(".footer-item");

      footerItems.forEach((item, index) => {
        if (index === 0) return;

        const title = item.querySelector(".footer-item__title");
        const content = item.querySelector(
          ".footer-item__content, .footer-item__menu"
        );

        if (!title || !content) return;

        content.style.display = "none";
        title.style.cursor = "pointer";

        const toggle = () => {
          const isVisible = content.style.display === "block";
          content.style.display = isVisible ? "none" : "block";
          title.classList.contains("active")
            ? title.classList.remove("active")
            : title.classList.add("active");
        };

        title.addEventListener("click", toggle);
        listeners.push({ title, toggle });
      });

      isAccordionActive = true;
    };

    const destroyAccordion = () => {
      listeners.forEach(({ title, toggle }) => {
        title.removeEventListener("click", toggle);
        const content = title.parentElement.querySelector(
          ".footer-item__content, .footer-item__menu"
        );
        if (content) {
          content.style.display = "";
        }
        title.style.cursor = "";
      });

      listeners = [];
      isAccordionActive = false;
    };

    const handleResize = () => {
      if (window.innerWidth <= 768 && !isAccordionActive) {
        initAccordion();
      } else if (window.innerWidth > 768 && isAccordionActive) {
        destroyAccordion();
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);
  }
}
customElements.define("main-footer", Footer);
